module.exports = __webpack_public_path__ + "4e77ada0983bd065e04d206f1943c70a.woff2";